import { Link } from '@tanstack/react-router';
import { AuthLayout } from '../auth/AuthLayout.js';

/** Any address the app does not know: say so plainly and offer the way back, instead of a bare "Not Found". */
export function NotFound() {
  return (
    <AuthLayout>
      <h1>Page not found</h1>
      <p>This link may be old, or the address may have a typo.</p>
      <Link to="/" className="btn btn-primary">Go to Chapsi</Link>
    </AuthLayout>
  );
}
